import styled from 'styled-components/macro'

import { IconArrowRight, IconClock } from '@loadsmart/icons'
import { Tag } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { Equipment } from 'legacy/components/LoadOffer/Equipment'

import { Card, BookButton, BidButton } from './OfferCard.styles'

export { Card as CardDesktop }

export const CardColumnsContainerDesktop = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
  padding: 10px 10px 10px 10px;
`

export const LeftColumnDesktop = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding-right: 20px;
  overflow: hidden;
`

export const RightColumnDesktop = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-shrink: 0;
  align-items: space-between;
  align-self: stretch;
  justify-content: space-between;

  > :not(:last-child) {
    margin-bottom: 10px;
  }
`

export const TopSectionDesktop = styled.section`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-self: flex-end;
`

export const BottomSectionDesktop = styled.section`
  display: flex;
  flex-flow: column nowrap;
  flex-flow: row nowrap;
  align-items: center;
  align-self: flex-end;

  > :not(:last-child) {
    margin-right: 10px;
  }
`

export const RouteDesktop = styled.div`
  display: flex;

  flex-flow: row wrap;
  align-items: center;
`

export const StyledIconArrowRight = styled(IconArrowRight)`
  display: inline-block;

  width: 13px;
  height: 13px;
  margin: 0 24px;
`

export const RowBreakDesktop = styled.div`
  flex-basis: 100%;
  height: 20px;
`

export const DetailsDesktop = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex-shrink: 1;
  align-items: center;
  width: 100%;
  margin-top: 8px;
`

export const OfferActionsDesktop = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;

  > :not(:last-child) {
    margin-right: 5px;
  }
`

export const BookButtonDesktop = styled(BookButton)`
  width: 120px;
`

export const BidButtonDesktop = styled(BidButton)`
  min-width: 56px;
  padding: 10px;
`

export const StyledIconClock = styled(IconClock)`
  display: inline-block;

  width: 20px;
  height: 20px;
  margin-right: -2px;
  margin-left: 2px;
`

export const StyledSmallLeftIconClock = styled(IconClock)`
  display: inline-block;

  width: ${getToken('space-m')};
  height: ${getToken('space-m')};
  margin-left: -${getToken('space-2xs')};
  margin-right: ${getToken('space-xs')};
`

export const EquipmentDesktop = styled(Equipment)`
  margin-right: 16px;
`

export const PalletizedTag = styled(Tag)`
  margin-right: 1rem;
`
